module.exports = __webpack_public_path__ + "static/media/applemusic.5db46de6.svg";